export default __webpack_public_path__ + "static/media/reweave-invert.e6fe3439.png";